module.exports = __webpack_public_path__ + "img/BC-S1.cda9f47f.jpg";